import getPermittedServersRoutes from './getPermittedServersRoutes';
import ROUTE_NAMES from '../../../../vue/routes/routeNames';

export default (): string => (
    getPermittedServersRoutes().length
        ? getPermittedServersRoutes()[0].name
        : ROUTE_NAMES.ADMIN_GENERAL
);
